import React, { useState, useEffect } from "react";

import UpdateUserTabs from "./UpdateUserTabs";
import Header from "../../components/common/Header";

import { gamesApi } from "../../api/games";
import { useAuth } from "../../context/AuthContext";
import { userApi } from "../../api/user";
export default function UpdateUser() {
  const { tokens, user } = useAuth();
  const userTab = ["Games", "Profile", "Log"];
  const [userId, setUserId] = useState(null);
  const [games, setGames] = useState([]);
  const [allGameSettings, setAllGameSettings] = useState([]);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const userId = window.location.pathname.split("/").pop();
    setUserId(userId);
    
    const fetchData = async () => {
      // Fetch user games
      const gamesResponse = await gamesApi.getUserGame(tokens.access.token, userId);
      if (gamesResponse.status === 200) {
        setGames(gamesResponse.data);
      }

      // Fetch all game settings
      const settingsResponse = await gamesApi.getAllGames(tokens.access.token);
      if (settingsResponse.status === 200) {
        setAllGameSettings(settingsResponse.data);
      }

      // Fetch user by id
      const userResponse = await userApi.getUserById(tokens.access.token, userId);
      if (userResponse.status === 200) {
        setUserData(userResponse.data);
      }
    };

    fetchData();
  }, [tokens.access.token]);
  
  return (
    <div className="min-h-screen  relative overflow-hidden  font-poppins ">
      <Header title={userData?.user?.name} />

      <UpdateUserTabs 
        userId={userId}
        userTab={userTab} 
        games={games}
        allGameSettings={allGameSettings}
        userData={userData}
      />
    </div>
  );
}
